import Color from 'color'

// colors
const black = '#111111'
const white = '#ffffff'
const tonic = '#00FFBE'

// blues
const blueDeep = '#000023'
const blueUltraDark = '#00045A'
const blueDark = '#00007A'
const blueMedium = '#000093'
const blueMediumLight = Color(blueMedium).alpha(0.2).toString()
const blueElectric = '#0000FF'
const blueElectricLight = Color(blueElectric).alpha(0.4).toString()
const blueElectricLighter = Color(blueElectric).alpha(0.1).toString()
const blueSky = '#A5FAFF'

// purples
const purple = '#43279C' // purple
const purpleMedium = '#905CE2'
const purpleLight = '#AA8FEE'
const separator = Color(purpleLight).alpha(0.3).hsl().toString()

export default {
  opacity: 0.4,
  labelOpacity: 0.6,

  // colors
  black,
  white,
  tonic,

  // blues
  blueDeep,
  blueUltraDark,
  blueDark,
  blueMedium,
  blueMediumLight,
  blueElectric,
  blueElectricLight,
  blueElectricLighter,
  blueSky,

  // purples
  purpleMedium,
  purple,
  purpleLight,

  // component
  separator,
  paragraphs: {
  },
  labels: {
  },
  titles: {
    title1: {},
    title2: {},
    title3: {},
    title4: {}
  }
}
